export const CHALLENGE_TYPE = {
  OTP: 'otp',
};
